import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col ml-3" }
const _hoisted_3 = { class: "timeline-content d-flex" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = {
  key: 0,
  class: "card-header border-0"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-sm btn-success me-3",
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": "#kt_modal_pre_implementasi"
    }, " Tambah Pre Implementasi ")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "symbol symbol-35px me-2",
    title: "Edit",
    style: {"cursor":"pointer"},
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_pre_implementasi"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/icons/edit.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_pre_implementasi",
  ref: "uploadModalRef"
}
const _hoisted_22 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_23 = { class: "modal-content rounded" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, " Update Pre Implementasi "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_25 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-xl-6 mb-8" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_29 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "col-xl-6 mb-8" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_34 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-xl-6 mb-8" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_40 = { class: "col-xl-6 mb-8" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Proses", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Proses", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", {
  value: "true",
  key: "true"
}, "Sudah", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  value: "false",
  key: "false"
}, "Belum", -1)
const _hoisted_45 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "modal-footer" }
const _hoisted_49 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.tampilPreImplementasi.actorName == null || '' )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              (_ctx.tampilPreImplementasi.actorName != null )
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.tampilPreImplementasi.progressDate), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.tampilPreImplementasi.actorName), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.tampilPreImplementasi.processed == true ? 'Sudah' : 'Belum'), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.tampilPreImplementasi.note.length > 50 ? _ctx.tampilPreImplementasi.note.substring(0, 50) + ' ...' : _ctx.tampilPreImplementasi.note), 1),
                      _hoisted_17
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_18, _hoisted_20))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "actorName",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Penanggung Jawab",
                      modelValue: _ctx.updatePreImplementasi.actorName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatePreImplementasi.actorName) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.updatePreImplementasi.actorName == '' || _ctx.updatePreImplementasi.actorName == null )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.items.erroractorName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "progressDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Tanggal",
                      modelValue: _ctx.updatePreImplementasi.progressDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatePreImplementasi.progressDate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.updatePreImplementasi.progressDate == '' || _ctx.updatePreImplementasi.progressDate == null )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.items.errorprogressDate), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36))
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Isi Catatan",
                      name: "note",
                      autocomplete: "off",
                      rows: "5",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updatePreImplementasi.note) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.updatePreImplementasi.note]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "processed",
                      autocomplete: "off",
                      modelValue: _ctx.updatePreImplementasi.processed,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updatePreImplementasi.processed) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42,
                        _hoisted_43,
                        _hoisted_44
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.updatePreImplementasi.processed == '' || _ctx.updatePreImplementasi.processed == null )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.items.errorprocessed), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.kosongkanVariabel()))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitAdd())),
                  disabled: _ctx.items.disableButton
                }, " Simpan ", 8, _hoisted_49)
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}